import { render, staticRenderFns } from "./final-table.vue?vue&type=template&id=13fa1f15&scoped=true"
import script from "./final-table.vue?vue&type=script&lang=js"
export * from "./final-table.vue?vue&type=script&lang=js"
import style0 from "./final-table.vue?vue&type=style&index=0&id=13fa1f15&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13fa1f15",
  null
  
)

export default component.exports